import React from 'react';
import Search from './components/Search';
import ApkTypeSelect from './components/ApkTypeSelect';
import ResetBtn from './components/ResetBtn';
import UnassignedCheckbox from './components/UnassignedCheckbox';
import AssignBtn from './components/AssignBtn';
import style from './ApkControlPanel.module.scss';

const ApkControlPanel: React.FC = () => {
	return (
		<div data-test="ApkControlPanel">
			<Search />
			<div className={style.firstControlUnit}>
				<ApkTypeSelect />
				<ResetBtn />
			</div>
			<div className={style.secondControlUnit}>
				<UnassignedCheckbox />
				<AssignBtn />
			</div>
		</div>
	);
};

export default ApkControlPanel;
